<template>
    <div class="edit-user">
        <admin-layout>
            <app-content-pane class="ml-3">
                <template #title>
                    <div class="px-4 pt-3">
                        <h1>{{ is_create_user ? 'Create User' : 'Edit User' }}</h1>
                        <nav>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a :href="route('usr.index', {...global_url_params})">Users</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ is_create_user ? 'Create User' : 'Edit User' }}
                                </li>
                            </ol>
                        </nav>
                    </div>
                </template>

                <hr>

                <form action="#" method="post" @submit.prevent="saveUser()" class="px-4 py-3">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="first_name">First Name</label>
                                        <input id="first_name" type="text" placeholder="First Name" class="form-control" v-model="form.first_name">
                                        <error-line field="first_name"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="last_name">Last Name</label>
                                        <input id="last_name" type="text" placeholder="Last Name" class="form-control" v-model="form.last_name">
                                        <error-line field="last_name"/>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="email">Email</label>
                                <input id="email" type="email" placeholder="email@domain.com" class="form-control" v-model="form.email">
                                <error-line field="email"/>
                            </div>

                            <template v-if="is_admin">
                                <div class="form-group">
                                    <label for="type">User Type</label>
                                    <select id="type"
                                            class="form-control"
                                            v-model="form.type">
                                        <option value="teacher">Teacher</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                    <error-line field="type"/>
                                </div>
                                <div class="form-group">
                                    <label for="account-type">Account Type</label>
                                    <select id="account-type"
                                            class="form-control"
                                            v-model="form.account_type">
                                        <option value="free">Free</option>
                                        <option value="paid">Paid</option>
                                    </select>
                                    <error-line field="type"/>
                                </div>
                                <div class="form-group" v-if="form.account_type === 'paid'">
                                    <label for="account-trial_expire_at">Trial Expiry</label>
                                    <select id="account-trial_expire_at"
                                            class="form-control"
                                            v-model="form.trial_expire_at">
                                        <option :value="null">Never</option>
                                        <option v-for="day in trial_days" :value="day.value">
                                            {{ day.value }} -
                                            <template v-if="day.day === 0">
                                                Today
                                            </template>
                                            <template v-else>
                                                in {{ day.day }} day{{ day.day > 1 ? 's' : '' }}
                                            </template>
                                            <template v-if="day.value === usr.trial_expire_at"> (SELECTED)</template>
                                        </option>
                                    </select>
                                    <error-line field="trial_expire_at"/>
                                </div>
                            </template>


                            <!-- Organization Editing -->

                            <div class="bg-light p-3 mb-3 rounded">
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input type="radio"
                                           class="custom-control-input"
                                           name="create-organization"
                                           id="create-organization"
                                           v-model="form.has_organization"
                                           :value="true">
                                    <label class="custom-control-label"
                                           for="create-organization">Is a teacher in an Organization</label>
                                </div>
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input type="radio"
                                           class="custom-control-input"
                                           name="create-organization"
                                           id="create-non-organization"
                                           v-model="form.has_organization"
                                           :value="false">
                                    <label class="custom-control-label"
                                           for="create-non-organization">Is a parent</label>
                                </div>
                            </div>

                            <div v-if="form.has_organization" class="card mb-3">

                                <div class="card-header">
                                    <h5 class="mb-0">Organization</h5>
                                </div>

                                <div class="card-body" v-if="form.create_organization || form.organization.id">

                                    <template v-if="form.create_organization">

                                        <div class="form-group">
                                            <label for="organization-name">Organization Name</label>
                                            <input class="form-control"
                                                   type="text"
                                                   id="organization-name"
                                                   placeholder="Name of your organization or a place"
                                                   v-model="form.organization.name">
                                            <error-line field="organization.name"/>
                                        </div>

                                        <div class="form-group">
                                            <label for="organization-address">Organization Address</label>
                                            <textarea class="form-control"
                                                      v-model="form.organization.address"
                                                      id="organization-address"
                                                      placeholder="Full address of the vicinity"></textarea>
                                            <error-line field="organization.address"/>
                                        </div>

                                    </template>

                                    <template v-else>

                                        <div v-if="form.organization.id" class="organization">
                                            <div class="font-weight-bold mb-1">
                                                <inertia-link v-if="is_admin && (form?.organization?.id ?? false)"
                                                              :href="route('organization.edit', {organization: form.organization.id, ...global_url_params})">
                                                    {{ form.organization.name }}
                                                </inertia-link>
                                                <span v-else>{{ form.organization.name }}</span>
                                            </div>
                                            <div>{{ form.organization.address }}</div>
                                        </div>

                                    </template>

                                </div>


                                <div class="card-footer">

                                    <template v-if="form.create_organization">
                                        <p class="mt-3">
                                            Want to give search a try again?
                                            <a @click.prevent.stop="createOrganization(false)"
                                               href="#">Search for an existing organization or a place</a>.
                                        </p>
                                    </template>

                                    <template v-else>
                                        <div class="form-group">
                                            <label for="organization">Search for an organization or a place to change your organization.</label>
                                            <input placeholder="Start typing to search..."
                                                   v-model="search.query"
                                                   id="organization"
                                                   class="form-control"
                                                   autocomplete="off"
                                                   @keyup="debouncedPlaceSearch"/>
                                        </div>

                                        <template v-if="search.query">
                                            <div v-if="search.results.length" class="results">
                                                <label class="mr-2">Below are the organizations that we're able to find.</label>
                                                <div class="custom-control custom-radio search-item" v-for="item in search.results" :key="item.id">
                                                    <template v-if="item.type === 'org'">
                                                        <input type="radio"
                                                               :id="`search-item-${item.id}`"
                                                               name="search-item"
                                                               v-model="search.selected"
                                                               :value="item.id"
                                                               class="custom-control-input">
                                                        <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                            <strong>{{ item.value.name }}</strong>
                                                            <div>{{ item.value.meta?.address }}</div>
                                                        </label>
                                                    </template>
                                                    <template v-if="item.type === 'ac'">
                                                        <input type="radio"
                                                               :id="`search-item-${item.id}`"
                                                               name="search-item"
                                                               v-model="search.selected"
                                                               :value="item.id"
                                                               class="custom-control-input">
                                                        <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                            <strong>{{ item.value?.structured_formatting?.main_text }}</strong>
                                                            <div>{{ item.value?.structured_formatting?.secondary_text }}</div>
                                                        </label>
                                                    </template>
                                                </div>
                                            </div>

                                            <p class="mt-3" v-if="!search.is_busy">
                                                Can't find your organization or place?
                                                <a @click.prevent.stop="createOrganization(true)"
                                                   href="#">Create new organization</a>.
                                            </p>

                                        </template>
                                    </template>
                                </div>

                            </div>
                            <!-- Organization Management Ends -->

                        </div>
                        <div class="col-md-6">

                        </div>
                    </div>

                    <div class="form-group">
                        <state-button class="btn btn-primary" type="submit">
                            {{ is_create_user ? 'Create User' : 'Save User' }}
                        </state-button>
                    </div>

                </form>

            </app-content-pane>
        </admin-layout>
    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import StateButton from "@/Components/Common/StateButton";
import ErrorLine from "@/Components/Common/ErrorLine";
import API from "@/API";
import trial from "@/mixins/trial.js";
export default {
    name: "Edit",
    components: {StateButton, AppContentPane, AdminLayout, ErrorLine},
    mixins: [trial],
    props: ['usr', 'organizations'],


    data(){
      return {

          debouncedPlaceSearch: _.debounce(() => this.searchPlace(), 500),

          search: {
              is_busy: false,
              selected: null,
              query: '',
              results: [],
          },

          form: this.$inertia.form({
              first_name: '',
              last_name: '',
              type: 'teacher',
              account_type: 'free',
              email: '',

              organization: {
                  name: '',
                  address: '',
                  type: null,
                  id: null,
              },

              trial_expire_at: null,

              has_organization: false,
              create_organization: false,
          }),


          trial_days: [],

      }
    },

    computed: {

        is_edit_user(){
            return typeof this.usr !== "undefined" && !!this.usr;
        },

        is_create_user(){
            return !this.is_edit_user;
        },

        saved_organization(){
            return this.organizations.length > 0 ? this.organizations[0] : null;
        },

        selected_item_id(){
            return this.search.selected;
        }

    },


    watch: {
        selected_item_id(val){
            const selected = this.search.results.find(item => item.id === val);
            if( selected ){

                this.form.organization.type = selected.type;

                switch ( selected.type ){
                    case 'ac':
                        this.form.organization.id = selected.value.place_id;
                        this.form.organization.name = selected.value?.structured_formatting?.main_text;
                        this.form.organization.address = selected.value?.structured_formatting?.secondary_text;
                        break;

                    case 'org':
                        this.form.organization.id = selected.value.id;
                        this.form.organization.name = selected.value.name;
                        this.form.organization.address = selected.value.meta?.address;
                        break;
                }

            }else{
                this.setDefaultOrganization();
            }
        }
    },


    methods: {


        formatDate(date){
            if( typeof date === 'string' ){
                date = new Date( Date.parse( date ) );
            }
            return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}`;
        },

        initUserData(){
            if( this.is_edit_user ){
                this.form.first_name    = this.usr.first_name;
                this.form.last_name     = this.usr.last_name;
                this.form.email         = this.usr.email;
                this.form.type          = this.usr.type;
                this.form.account_type  = this.usr.account_type;
                this.form.trial_expire_at = this.usr.trial_expire_at;
            }
        },


        async searchPlace(){
            this.clearPlaceSearch();
            if( jQuery.trim( this.search.query ).length <= 0 ) return;
            this.search.is_busy = true;
            this.search.results = await API.organizations.search({q: this.search.query});
            this.search.is_busy = false;
        },


        clearPlaceSearch(){
            this.search.is_busy = false;
            this.search.selected = null;
            this.search.results.length = 0;

            this.setDefaultOrganization();

        },

        createOrganization(create){
            this.clearPlaceSearch();
            this.search.query = '';
            this.form.create_organization = !!create;
        },

        setDefaultOrganization(){

            if( this.saved_organization ){
                this.form.has_organization = !! (this.saved_organization?.id ?? false);
                this.form.organization.id = this.saved_organization.id;
                this.form.organization.type = 'org';
                this.form.organization.name = this.saved_organization.name;
                this.form.organization.address = this.saved_organization.meta?.address;
            }else{
                // this.form.has_organization = force_has_organization === true;
                this.form.organization.id = null;
                this.form.organization.type = null;
                this.form.organization.name = '';
                this.form.organization.address = '';
            }

        },


        createUser(){
            this.form.post(this.route('usr.store', {
                ...this.global_url_params
            }), {
                onSuccess(res){
                    console.log({create: res});
                }
            });
        },

        updateUser(){
            this.form.put(this.route('usr.update', {
                usr: this.usr.id,
                ...this.global_url_params
            }), {
                onSuccess(res){
                    console.log({update: res});
                }
            });
        },

        saveUser(){

            if( this.is_create_user ){
                this.createUser();
            } else {
                this.updateUser();
            }

        }
    },

    beforeMount() {
        this.setDefaultOrganization();
        this.initUserData();

        let saved_trial_day = null;
        if( this.form.trial_expire_at ){
            saved_trial_day = {
                value: this.formatDate( this.form.trial_expire_at ),
                day: this.usr.trial_expires_in,
            }
        }

        let added_saved = false;
        for (const day of this.trial_days_options){

            // Skip the loop if it is already saved in the user's trial date.
            if( ! added_saved && saved_trial_day && day >= saved_trial_day.day ){
                this.trial_days.push(saved_trial_day);
                added_saved = true;

                if( day === saved_trial_day.day ){
                    continue;
                }
            }

            const date = new Date();
            date.setDate( date.getDate() + day );
            const date_formatted = this.formatDate(date);

            this.trial_days.push({value: date_formatted, day});
        }

    },

    mounted(){
        this.setTitle( this.is_create_user ? 'Create User' : "Edit User '" + this.form.first_name + " " + this.form.last_name + "'" );
    }

}
</script>

<style lang="scss" scoped>
.results{
    border-bottom: $light-borders solid 1px;
    padding-bottom: 1rem;
}
</style>
